import { Stack } from '@mui/material';
import * as React from 'react';
import { FormArrayFieldProps } from 'components/form-fields/FormArrayFields';
import FormTextFieldInlineEdit from 'components/form-fields/FormTextFieldInlineEdit';
import FormArrayRemoveButton from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/form-components/FormArrayRemoveButton';
import FormWithCommandAutoComplete from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/form-components/FormWithCommandAutoComplete';
import OptionLabelSelector from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/options-question/OptionLabelSelector';
import {
  OptionsQuestionStepFormFieldsNames,
  OptionsQuestionStepFormFieldsOptionsNames,
} from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/options-question/types';
import { OptionsQuestionFormOptionsFieldsConfig } from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/options-question/utils';
import { lowerCaseAndUnderscore } from 'utils';

const AnswersFormArrayField = ({ getFieldName, index, remove, length }: FormArrayFieldProps) => {
  const { name, label, ...rest } =
    OptionsQuestionFormOptionsFieldsConfig[OptionsQuestionStepFormFieldsOptionsNames.Answer];

  const valueConfig =
    OptionsQuestionFormOptionsFieldsConfig[OptionsQuestionStepFormFieldsOptionsNames.Value];

  const answerFieldName = getFieldName(name);
  const labelsFieldName = getFieldName(OptionsQuestionStepFormFieldsOptionsNames.Labels);
  const valueFieldName = getFieldName(OptionsQuestionStepFormFieldsOptionsNames.Value);

  return (
    <Stack gap={0.5}>
      <Stack direction='row' alignItems='flex-start' gap={0.5}>
        <Stack gap={0.5} flex={1}>
          <FormWithCommandAutoComplete
            name={answerFieldName}
            parentName={OptionsQuestionStepFormFieldsNames.Answers}
            placeholder={`${label} ${index + 1}`}
            {...rest}
          />
          <FormTextFieldInlineEdit
            {...valueConfig}
            name={valueFieldName}
            text='add value'
            icon='data_object'
            size='small'
            textVariant='caption'
            tooltipPlacement='left'
            valueManipulator={lowerCaseAndUnderscore}
            tooltip='Click to add a value to this option answer. This is how the option will be saved and referenced.'
            startAdornment
          />
        </Stack>
        <OptionLabelSelector fieldName={labelsFieldName} />
        <FormArrayRemoveButton onClick={() => remove(index)} disabled={length === 1} />
      </Stack>
    </Stack>
  );
};

export default AnswersFormArrayField;
